import React from 'react';
import Badge from '../ui/Badge';

const WALNUT = '#8B4513';
const STONE = '#8C8275';

export default function CalendarFilters({
  selectedStatuses = [], onStatusToggle,
  selectedCrews = [], onCrewToggle
}) {
  const statuses = [
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' }
  ];
  const crews = [
    { value: 'crew-1', label: 'Crew 1' },
    { value: 'crew-2', label: 'Crew 2' }
  ];

  const chipStyle = (active) => ({
    padding: '6px 14px',
    background: active ? `${WALNUT}1A` : 'transparent',
    border: active
      ? `2px solid ${WALNUT}`
      : `2px solid ${STONE}44`,
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '600',
    color: active ? WALNUT : STONE,
    cursor: 'pointer',
    transition: 'all 0.2s'
  });

  return (
    <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '13px', color: STONE, fontWeight: '500' }}>Status:</span>
        {statuses.map(status => (
          <button
            key={status.value}
            onClick={() => onStatusToggle(status.value)}
            style={chipStyle(selectedStatuses.includes(status.value))}
          >{status.label}</button>
        ))}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '13px', color: STONE, fontWeight: '500' }}>Crew:</span>
        {crews.map(crew => (
          <button
            key={crew.value}
            onClick={() => onCrewToggle(crew.value)}
            style={chipStyle(selectedCrews.includes(crew.value))}
          >{crew.label}</button>
        ))}
      </div>
    </div>
  );
}
